import React, { useState } from "react";
import { GlobalMetrics } from "./components/HeaderMetrics";
import { RoutineClients } from "./components/RoutineClients";

// eslint-disable-next-line import/prefer-default-export
export function ClientAnalitics() {
    const [daysSelected, setDaysSelected] = useState('')
    return (
        <section>
            <h5>Análise de clientes</h5>
            <GlobalMetrics daysSelected={daysSelected} setDaysSelected={setDaysSelected} />
            <RoutineClients daysSelected={daysSelected} />
        </section>
    )
}